import { Component, OnDestroy, OnInit } from "@angular/core";
import { DialogCloseResult, DialogService } from "@progress/kendo-angular-dialog";
import { CedNotificationService } from "ced-ng-library";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ActionTypeDetailComponent } from "../actionType-details/actionType-details.component";
import { WorkActivityService } from "../workActivity-service";
import { WorkActivityModel } from "../workActivity.model";

@Component({
    selector: 'app-actionType-list',
    templateUrl: './actionType-list.component.html',
    styleUrls: ['./actionType-list.component.scss']
})

export class ActionTypeListComponent implements OnInit, OnDestroy {

    private _subject$: Subject<boolean> = new Subject();
    public isloading: boolean = false;
    workActivities: WorkActivityModel[] = [];
    public selectedWorkActivity: WorkActivityModel = null;
    
    constructor(private dialogService: DialogService,
        private cedNotificationService: CedNotificationService,
        private workActivityService: WorkActivityService) { }
    
    ngOnInit() {
        this.getActionTypes();
    }

    getActionTypes() {
        this.isloading = true;
        this.workActivityService
        .getAll()
        .pipe(takeUntil(this._subject$))
        .subscribe((data: any) => {
          this.workActivities = data;        
          this.isloading = false;
        });
      }

      onCellClick($event) {
        this.selectedWorkActivity = $event.dataItem;
      }

      openDetails() {
        if (this.selectedWorkActivity != null)
          this.openDialog();
        this.selectedWorkActivity = null;
      }

      openDialog() {
        const dialogRef = this.dialogService.open({
            content: ActionTypeDetailComponent,
          width:"80%"
        });
        dialogRef.content.instance.selectedWorkActivity = this.selectedWorkActivity; 

        dialogRef.result.subscribe((result: any) => { 
            if (!(result instanceof DialogCloseResult)) {
                this.cedNotificationService.success("MANAGEMENT.ACTIONTYPES.SAVESUCCESS") ;
                this.getActionTypes();
            }
            this.selectedWorkActivity = null;
          });
      }  

    ngOnDestroy(): void {
        this._subject$.next();
        this._subject$.complete();
    }
}